import React, { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { VideoSeriesInput } from "../store/actionType";
import { createVideoSeries } from "../store/action";
import { CreateFolderForm } from "modules/video/components/CreateFolderForm";
import {
  CreateFolderInput,
  CreateFolderError,
} from "modules/video/components/DataType";
import { VideoCategoryProps } from "modules/video/category/store/actionType";
import { ApiError } from "components";

interface CreateSeriesProps {
  categoryFolderData: VideoCategoryProps;
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
}

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & CreateSeriesProps;

const CreateSeries: React.FC<Props> = ({
  closeModal,
  categoryFolderData,
  onCreatehVideoSeries,
}) => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState<CreateFolderInput>({
    title: "",
    series_order: 0,
  });
  const [error, setError] = useState<CreateFolderError>({});
  const [apiError, setApiError] = useState(null);
  const seriesState = useSelector(
    (state: any) => state.videoSeries?.videoSeriesState
  );

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value, type } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "number" ? Number(value) : value,
    }));
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleSave = async (e: FormEvent) => {
    e.preventDefault();
    var input: VideoSeriesInput = {
      title: formData.title,
      series_order: formData.series_order,
      category_id: categoryFolderData?.id.toString(),
      category_folder_id: categoryFolderData?.folder_id.toString(),
    };
    if (formData.title.trim() === "") {
      setError((prevErrors) => ({
        ...prevErrors,
        title: "Series Title is required",
      }));
    }
    if (formData.series_order === 0) {
      setError((prevErrors) => ({
        ...prevErrors,
        series_order: "Series Order is required",
      }));
    }
    if (formData.title.trim() !== "" && formData.series_order !== null) {
      setLoading(true);
      onCreatehVideoSeries(input);
      setSubmitted(true)
      setLoading(false);
    }
  };
 useEffect(() => {
     if (!seriesState.isLoading && submitted) {
       if (seriesState.error) {
         setApiError(seriesState.error); // show error
       } else {
         setApiError(null);
         closeModal(false);
       }
     }
   }, [seriesState.isLoading, seriesState.error, submitted, closeModal]);
  return (
    <>
      <CreateFolderForm
        handleChange={handleChange}
        handleSubmit={handleSave}
        formData={formData}
        formErrors={error}
        loading={loading}
        header={"Create Series"}
      />
      {apiError && <ApiError>{apiError}</ApiError>}
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  onCreatehVideoSeries: (input: VideoSeriesInput) =>
    dispatch(createVideoSeries(input)),
});

export default connect(null, mapDispatchToProps)(CreateSeries);
